require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-category-lead-generation.json") })
        }
      }, "path---tapd-in-category-lead-generation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-category-lead-generation!./.cache/json/tapd-in-category-lead-generation.json
// module id = 814
// module chunks = 231608221292675